/* eslint-disable complexity */
var dialog = require('_core_ext/dialog'),
    searchsuggest = require('_core_ext/searchsuggest-beta'),
    util = require('_core_ext/util'),
    noScroll = require('_core_ext/components/noscroll'),
    _throttle = require('lodash/function/throttle'),
    ajax = require('_core_ext/ajax');

const eventMgr = require('_core_ext/eventMgr');
const Promise = require('promise');
require('es6-promise').polyfill();

/**
 * @description Moved from SG app.js
 */
function initializeEvents() {
    var $document = $(document);
    var $header = $('.js-header');

    /**
     * initialize search suggestions if not disabled by isSearchSuggestionsDisabled site preference
     * */
    if ($header.length) {
        var $searchField = $header.find('.js-header-search-field'),
            $searchContainer = $header.find('#header-search-form-wrapper');
        $header.on('click', '.js-header-search-icon', function(e) {
            e.preventDefault();

            var $this = $(this);
            $this.toggleClass('expanded');
            $this.parent().toggleClass('expanded');
            $this.next('.toggle-content').toggleClass('expanded');
            if ($(this).hasClass('expanded')) {
                $searchField.trigger('focus');
            }
            return false;
        });

        if (!SitePreferences.SEARCH_SUGGESTIONS_DISABLED) {
            searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);
        }
    }

    // add show/hide navigation elements
    var $secondaryNavigation = $('.secondary-navigation .js-toggle-nav');
    $secondaryNavigation.on('click', function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // check that slot wrapper is not empty in drop down menu
    $('#navigation').find('.menu-content-wrapper').each(function() {
        var currentWrapper = $(this),
            dataColumns, wrapper;
        if ($(this).find('.slot').length > 0) {
            wrapper = currentWrapper.closest('.level-2-content');
            dataColumns = parseInt(wrapper.data('columns'), 10);
            wrapper.removeClass('menu-category-columns-' + dataColumns);
            dataColumns++;
            wrapper.attr('data-columns' , dataColumns);
            wrapper.addClass('menu-category-columns-' + dataColumns);
        }
    });

    //add show/hide footer
    var footerEmitter = eventMgr.getEmitter('footer');
    $('.footer-column').on('click', 'dt', function() {
        $(this).toggleClass('expanded');
        var footer = $('.footer-container');
        footer.toggleClass('expanded');
        footerEmitter.emit('expanded', footer.hasClass('expanded'));
    });

    $('.footer-column').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            var $dt = $(this).find('dt');
            if ($dt.length) {
                $dt.toggleClass('expanded');
                var footer = $('.footer-container');
                footer.toggleClass('expanded');
                footerEmitter.emit('expanded', footer.hasClass('expanded'));
            }

            return false;
        }
    });

    // fire event when footer links gets in/out viewport (on mobile)
    const footerLinks = $('.footer-links');
    // if it's fixed - then it's always in viewport (desktop and tablet)
    if (footerLinks.length && footerLinks.css('position') !== 'fixed') {
        const footerLinksEl = footerLinks.get(0);
        let prevInViewport = util.elementInViewport(footerLinksEl, 0);
        $(window).on('scroll', _throttle(function() {
            if (util.elementInViewport(footerLinksEl, 0) && !prevInViewport) {
                // entered viewport
                footerEmitter.emit('inviewport', true);
                prevInViewport = true;

            } else if (!util.elementInViewport(footerLinksEl, 0) && prevInViewport) {
                // left viewport
                footerEmitter.emit('inviewport', false);
                prevInViewport = false;
            }
        }, 100));
    }

    // add generic toggle functionality
    /*$('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });*/

    $('.sizeselector-list .sizeselector-item_text').addClass('hidden');

    $document.on('keydown', '.sizeselector-dropdown.js-toggle', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            var $el = $(this);
            e.preventDefault();

            if (!$el.hasClass('js-toggle-disabled')) {
                $el.toggleClass('expanded');

                var $sizeList = $el.next('.js-toggle-content');
                $sizeList.toggleClass('expanded');

                var isExpanded = $el.hasClass('expanded');
                $el.attr('aria-expanded', isExpanded);

                var $sizeOptions = $sizeList.find('.sizeselector-item_text');
                if (isExpanded) {
                    $sizeOptions.removeClass('hidden');

                    var $firstOption = $sizeOptions.first();
                    if ($firstOption.length) {
                        $firstOption.focus();
                    }
                } else {
                    $sizeOptions.addClass('hidden');
                }
            }

            return false;
        }
    });

    $document.on('keydown', '.category-link.js-toggle', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            var $el = $(this);
            e.preventDefault();

            if (!$el.hasClass('js-toggle-disabled')) {
                $el.toggleClass('expanded');

                var $sizeList = $el.next('.js-toggle-content');
                $sizeList.toggleClass('expanded');

                var isExpanded = $el.hasClass('expanded');
                $el.attr('aria-expanded', isExpanded);

                var $sizeOptions = $sizeList.find('.categories');
                if (isExpanded) {
                    $sizeOptions.removeClass('hidden');
                } else {
                    $sizeOptions.addClass('hidden');
                }
            }

            return false;
        }
    });

    $document.on('keydown', '.category-level-2 .category-link', function (e) {
        console.log('Keydown event triggered on:', this);
        console.log('Key pressed:', e.key);

        if (e.key === 'Escape') {
            var $currentItem = $(this);
            e.preventDefault();

            var $toggleContent = $currentItem.closest('.js-toggle-content');

            var $parentToggle = $toggleContent.prev('.category-link.js-toggle');

            if ($parentToggle.length && $parentToggle.hasClass('expanded')) {
                $parentToggle.removeClass('expanded');
                $parentToggle.attr('aria-expanded', false);

                $toggleContent.removeClass('expanded');

                var $categories = $toggleContent.find('.categories');
                $categories.addClass('hidden');

                $parentToggle.focus();
            }
            return false;
        }
    });

    $document.on('keydown', '.sizeselector-list .sizeselector-item', function (e) {
        var $currentItem = $(this);
        var $allItems = $currentItem.closest('.sizeselector-list').find('.sizeselector-item');
        var currentIndex = $allItems.index($currentItem);

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                var nextIndex = (currentIndex + 1) % $allItems.length;
                $allItems.eq(nextIndex).find('.sizeselector-item_text').focus();
                break;

            case 'ArrowUp':
                e.preventDefault();
                var prevIndex = currentIndex === 0 ? $allItems.length - 1 : currentIndex - 1;
                $allItems.eq(prevIndex).find('.sizeselector-item_text').focus();
                break;

            case 'Enter':
            case ' ':
                e.preventDefault();
                $currentItem.trigger('click');
                break;

            case 'Escape':
                e.preventDefault();
                var $dropdown = $currentItem.closest('.sizeselector').find('.sizeselector-dropdown');
                var $sizeList = $currentItem.closest('.sizeselector-list');

                $dropdown.removeClass('expanded').attr('aria-expanded', 'false');
                $sizeList.removeClass('expanded');

                $sizeList.find('.sizeselector-item_text').addClass('hidden');

                $dropdown.focus();
                break;
            default :
                break;
        }
    });

    $document.on('click', '.sizeselector-dropdown.js-toggle', function() {
        var $el = $(this);
        var $sizeList = $el.next('.js-toggle-content');
        var $sizeOptions = $sizeList.find('.sizeselector-item_text');

        // Check if dropdown will be expanded after this click
        setTimeout(function() {
            var isExpanded = $el.hasClass('expanded');
            if (isExpanded) {
                $sizeOptions.removeClass('hidden');
            } else {
                $sizeOptions.addClass('hidden');
            }
        }, 0);
    });

    $document.on('click', '.js-toggle, .toggle',function (e) {
        var $el = $(this);
        if (!$el.hasClass('js-toggle-disabled')) {
            $el.toggleClass('expanded');
            $el.next('.js-toggle-content, .toggle-content').toggleClass('expanded');
            if (!$el.hasClass('js-toggle-click') || $el.hasClass('js-toggle-prevent-click')) {
                e.preventDefault();
                return false;
            }
        }
    });

    // collapse toggle element with 'js-collapse-out-click' class when clicked outside of it, relates to '.js-toggle, .toggle' elements above
    $document.on('click', function (e) {
        // when clicked outside of toggle elem and it's target content
        if (!$(e.target).closest('.js-toggle, .toggle, .js-toggle-content, .toggle-content').length) {
            $('.js-toggle, .toggle')
                .filter('.js-collapse-out-click').removeClass('expanded').attr('aria-expanded', 'false')
                .next('.js-toggle-content, .toggle-content').removeClass('expanded').attr('aria-expanded', 'false');
        }
    });

    $document.on('touchstart', '.ui-dialog-titlebar-close',function () {
        $(this).trigger('click');
    });

    $document.on('click', '.js-toggle-collapse', function (e) {
        e.preventDefault();
        $('.js-toggle-collapse').not(this).removeClass('expanded');
    });

    $document.on('click', '.js-toggle-parent', function (e) {
        e.preventDefault();
        $(this).parent().find('.js-toggle').toggleClass('expanded');
    });

    // store details toggle functionality
    $document.on('click touchend', '.js-select-storecontent', function(e) {
        e.preventDefault();
        var $this = $(this),
            $parent = $this.parent().parent(),
            $storeDetails = $('.store-details-inner'),
            option = $this.text(),
            container = $this.data('storecontainer');

        $('.store-link-current').html(option);
        $storeDetails.children().hide();
        $storeDetails.find('.' + container).show();
        $parent.find('.js-toggle').toggleClass('expanded');
    });
    // can be RE-used as component's style - to collapse tabs, etc into custom dropdown select
    $('.js-collapse-to-dropdown').each(function() {
        $(this).find('.selected-value').text($(this).find('.collapse-to-dropdown__item:first a').text());
    });
    $document.on('click', '.js-collapse-to-dropdown',function (e) {
        e.preventDefault();
        $(this).toggleClass('expanded');
        $(this).find('ul').toggleClass('expanded');
    });
    $document.on('click', '.js-collapse-to-dropdown .collapse-to-dropdown__item',function (e) {
        e.preventDefault();
        $(this).closest('.collapse-to-dropdown').find('.selected-value').text($(this).find('a').text());
    });

    $document.on('click', function(e) {
        if (!$(e.target).closest('.js-isotope-filter-wrapper').length) {
            $('.js-isotope-filter-wrapper .js-toggle-collapse').removeClass('expanded');
            $('.js-isotope-filter-wrapper .js-toggle-content').find('ul').removeClass('expanded');
        }
    });

    $document.on('keydown', '.b-checkout_summary .b-checkout_summary-header.js-toggle', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            var $el = $(this);
            e.preventDefault();

            $el.toggleClass('expanded');
            $el.next('.b-checkout_summary-main_content_wrapper').toggleClass('expanded');

            var isExpanded = $el.hasClass('expanded');
            $el.attr('aria-expanded', isExpanded);

            var $productLink = $('.b-summary_product-name a');
            if (!isExpanded) {
                // When collapsed: remove from tab order
                $productLink.attr('tabindex', '-1');
            } else {
                // When expanded: make focusable again
                $productLink.removeAttr('tabindex');
            }

            return false;
        }
    });

    var wishlistItemsPromise = null;
    eventMgr.registerAction('common.updateWishlistCounter', function(data) {
        return new Promise((res) => {
            wishlistItemsPromise = null;    // reset stored items fetching promise if WL was updated
            var $headerWishlist = $('.js-header-wishlist');
            var $itemsCount = $headerWishlist.find('.js-wishlist-items-count');
            if ($itemsCount.length) {
                $headerWishlist.toggleClass('wishlist-empty', !data.count);
                res($itemsCount.text(data.count ? data.count : ''));
            }
        });
    });

    // action to fetch array product IDs that are in wishlist
    eventMgr.registerAction('common.getWishlistItems', function () {
        if (!wishlistItemsPromise) {
            wishlistItemsPromise = ajax.getJson({
                url: Urls.wishlistItems,
                dataType: 'jsonp'
            });
        }
        return wishlistItemsPromise;
    });

    // auto-add placeholders according to it's labels for assets. Can be expanded for more possible future cases.
    if ($('.pt_content .content-asset form').length > 0) {
        var $inputFields = $('.pt_content .content-asset form').find('input[type="text"], input[type="email"]');

        $inputFields.each(function() {
            var $field = $(this);

            if (util.isEmpty($field.attr('placeholder'))) {
                $field.attr('placeholder', $field.parent().siblings('label').text());
            }
        });
    }

    // ***** Amplience Phone Slider ******
    var $phoneSlider = $('.js-phone-slider');

    function setEqualContentHeight($selectors) {
        var maxSelectorHeight = 0;
        // get max selector height
        $selectors.each(function(i, item) {
            $(item).css('height','auto'); // reset height
            if ($(item)[0].clientHeight > maxSelectorHeight) {
                maxSelectorHeight =  $(item)[0].clientHeight;
            }
        });
        // set max selector height
        $selectors.each(function(i, item) {
            if ($(item)[0].clientHeight !== maxSelectorHeight) {
                $(item).css('height', maxSelectorHeight);
            }
        });
    }

    function updatePhoneSliderState($headers, $descriptions) {
        // set equal minimal height to fit all content
        setEqualContentHeight($headers);
        setEqualContentHeight($descriptions);
    }

    if ($phoneSlider.length > 0) {

        var $descriptions = $('.js-phone-slider').find('.phone-slide__description');
        var $headers = $('.js-phone-slider').find('.phone-slide__header');

        // apply window resize event actions to description (set equal minimal height to fit all description content)

        updatePhoneSliderState($headers, $descriptions); // init state;
        $(window).resize(function() {
            updatePhoneSliderState($headers, $descriptions);
        });
    }

    // Amplience resources (Slider Reveal Template)
    $('.js-twentytwenty-container').twentytwenty({
        /* eslint-disable camelcase */
        default_offset_pct: 0.7
        /* eslint-enable camelcase */
    });

    // ***** detect and handle inView functionality (when element appears or scrolled to in viewport) (usually it will trigger the animation) *****
    var $inViewSelectors = $('.js-inView');

    // handle annimation\appearance of selectors depending on current document scroll position
    function updateInViewStates($animationObjectsInQueue, animationSequenceDelay) {
        var windowBottomY = $document.scrollTop() + $(window).height();

        $inViewSelectors.each(function(i, item) {
            var selectorBottomY = $(item)[0].y + $(item)[0].offsetHeight;
            // if bottom of the object is in the viewport (so it's fully can be shown) AND it's not shown yet AND it doesn't have property set animation-triggered=true
            if (windowBottomY >= selectorBottomY && !$(this).hasClass('inView') && !$(this).data('animation-triggered')) {
                $(this).data('animation-triggered', true);
                $animationObjectsInQueue.push($(this));
            }
        });

        // if there's objects in the queue that are waiting to be shown - iterate through them and show each next with delay
        if ($animationObjectsInQueue.length > 0) {
            $animationObjectsInQueue.forEach(function(item, index) {
                setTimeout(function() {
                    $(item).addClass('inView'); // this class will trigger animation start (in css)
                }, index * animationSequenceDelay);
            });
            $animationObjectsInQueue = [];
        }
    }

    if ($inViewSelectors.length > 0) {
        var $animationObjectsInQueue = [];
        var animationSequenceDelay = 300; // ms - delay between 2 or more animations in a row

        updateInViewStates($animationObjectsInQueue, animationSequenceDelay); // init state;
        $document.on('scroll', function () {
            updateInViewStates($animationObjectsInQueue, animationSequenceDelay);
        });
    }

    $document.on('click touchend', '.js-toggle-mobile', function (e) {
        e.preventDefault();
        $(this).toggleClass('expanded-mobile');
        $(this).next('.js-toggle-content-mobile').toggleClass('expanded-mobile');
        if (!$(this).hasClass('js-toggle-click')) {
            return false;
        }
    });

    $document.on('click', '.js-toggle-content-mobile', function (e) {
        $(this).prev('.js-toggle-mobile').toggleClass('expanded-mobile');
        var $target = $(e.target);
        if (!$target.hasClass('js-toggle-click')) {
            e.preventDefault();
            return false;
        }
    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail.on('focus', function () {
            var val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({color: '#999999'}, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({color: '#333333'}, 500, 'linear');
        });
    }

    $('.privacy-policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    // main menu toggle
    if ($header.length) {
        const menuEmitter = eventMgr.getEmitter('mainmenu');
        if (util.isTouch()) {
            // this handles mobile hamburger and tablet(touch) desktop nav

            var $wrapper = $('#wrapper'), // page wrapper
                $nav = $('#navigation'), // main menu
                $menuCloseButton = $wrapper.find('.js-close-category-menu'), //hamburger menu Close button
                $window = $(window);

            if (util.isTablet()) {
                $header.addClass('is-tablet');

                $window.on('scroll', _throttle(function() {
                    var $el = $header.find('.js-menu-item-wrapper.active');

                    $el.find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');

                    $el.removeClass('active')
                        .closest('.js-menu-sub-level').removeClass('nested-item-active');
                    $el.trigger('mouseleave');
                    if ($el.length) {
                        menuEmitter.emit('closed');
                    }
                }, 100));
            }

            var openedMenus = new Set();
            var openedLevel3Menus = new Set();

            $header.on('click', '.js-menu-item', function (e) {

                var $el = $(this),
                    $parentWrapper = $el.closest('.js-menu-item-wrapper'),
                    $menuCategory = $el.closest('.menu-category'),
                    $parentLevel2Content = $el.closest('.level-2-content'),
                    $subItemsWrapper = $parentWrapper.find('.js-menu-sub-level'),
                    $level2 = $parentWrapper.find('.level-2'),
                    $level3 = $parentWrapper.find('.level-3');

                // Determine what level we're clicking on
                var isInLevel2 = $el.closest('.level-2').length > 0;
                var isInLevel3 = $el.closest('.level-3').length > 0;
                var menuLevel = isInLevel3 ? 3 : (isInLevel2 ? 2 : 1);

                // Use data-cgid or href as unique identifier
                var menuId = $parentWrapper.data('cgid') || $el.attr('href');

                // Check what submenus this item has
                var hasLevel2Submenu = $level2.length > 0;
                var hasLevel3Submenu = $level3.length > 0;
                var hasAnySubmenu = hasLevel2Submenu || hasLevel3Submenu || $subItemsWrapper.length > 0;

                if (menuLevel === 1) {
                    // LEVEL 1 CLICK - Main category (Women, Men, etc.)

                    var isAlreadyOpen = openedMenus.has(menuId);
                    var shouldOpenSubmenu = hasAnySubmenu && !isAlreadyOpen && !(util.isTablet() && $parentLevel2Content.length);

                    if (shouldOpenSubmenu) {
                        e.preventDefault();

                        // Clear other opened menus - enhanced cleanup
                        openedMenus.clear();
                        openedLevel3Menus.clear();

                        // Mark this menu as opened
                        openedMenus.add(menuId);

                        if (isHamburgerMenu()) {

                            // Close other active menus
                            $('.js-menu-item-wrapper.active').removeClass('active');
                            $('.js-menu-sub-level.nested-item-active').removeClass('nested-item-active');
                            $('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');

                            $parentWrapper.addClass('active');

                            if ($level2.length) {
                                $level2.removeClass('hidden nested-item-active');
                            }

                        } else {

                            // ENHANCED CLEANUP for non-hamburger mode
                            // Remove all menu-category-hover classes
                            $('.menu-category.menu-category-hover').each(function() {
                                $(this).removeClass('menu-category-hover no-transition');
                            });

                            // Remove all keyboard-hover classes
                            $('.js-menu-item-wrapper.keyboard-hover').each(function() {
                                $(this).removeClass('keyboard-hover');
                            });

                            // Reset all ARIA states
                            $('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');

                            // Now open the clicked menu
                            $menuCategory.addClass('menu-category-hover');

                            $parentWrapper.addClass('keyboard-hover');

                            if ($level2.length) {
                                $level2.removeClass('hidden');
                            }

                            setTimeout(function() {
                                $menuCategory.addClass('no-transition');
                            }, SitePreferences.MENU_TRANSITION_DURATION + 20);
                        }

                        if ($el.attr('aria-haspopup') === 'true') {
                            $el.attr('aria-expanded', 'true');
                        }

                        menuEmitter.emit('opened');
                        return false;

                    } else if (isAlreadyOpen) {
                        openedMenus.delete(menuId);
                        // Allow navigation
                    }

                } else if (menuLevel === 2) {
                    // LEVEL 2 CLICK - Subcategory (Clothing, Shoes, etc.)
                    var level3Id = menuId + '-level3';
                    var isLevel3AlreadyOpen = openedLevel3Menus.has(level3Id);
                    var shouldOpenLevel3 = hasLevel3Submenu && !isLevel3AlreadyOpen;

                    if (shouldOpenLevel3) {
                        e.preventDefault();

                        // Don't close level-2 menu, just manage level-3
                        openedLevel3Menus.clear(); // Close other level-3 menus
                        openedLevel3Menus.add(level3Id);

                        if (isHamburgerMenu()) {

                            // Close other active level-2 items
                            $parentWrapper.siblings('.active').removeClass('active');
                            $parentWrapper.siblings().find('.level-3').addClass('hidden');

                            $parentWrapper.addClass('active');

                            if ($level3.length) {
                                $level3.removeClass('hidden');
                            }

                        } else {

                            // For desktop, level-3 might work differently
                            $parentWrapper.siblings().removeClass('keyboard-hover');
                            $parentWrapper.addClass('keyboard-hover');

                            if ($level3.length) {
                                $level3.removeClass('hidden');
                            }
                        }

                        if ($el.attr('aria-haspopup') === 'true') {
                            $el.attr('aria-expanded', 'true');
                        }

                        return false;

                    } else if (isLevel3AlreadyOpen) {
                        openedLevel3Menus.delete(level3Id);
                        // Allow navigation
                    }

                }

            }).on('click', '.js-menu-back', function (e) {
                var $el = $(this),
                    $parentWrapper = $el.closest('.js-menu-item-wrapper');

                $parentWrapper.find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');
                $parentWrapper.removeClass('active')
                    .closest('.js-menu-sub-level').removeClass('nested-item-active');
                e.preventDefault();
                return false;
            }).on('click', '.js-menu-toggle', function () {
                var $headerCookies = $wrapper.find('.header-cookies');

                $nav.css('height', $(window).innerHeight());
                $nav.css('top', -$('.header-banner').height());
                $wrapper.addClass('menu-active');
                $menuCloseButton.css('top', $headerCookies.height());
                if ($wrapper.find('.is-sticky').length) {
                    $wrapper.find('#header-search-form-wrapper').css('opacity', '0');
                }
                noScroll.enable();
            });
            $menuCloseButton.on('click', function () {
                // Reset all ARIA states when closing hamburger menu
                $('#navigation .js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');

                noScroll.disable();
                $wrapper.removeClass('menu-active');
                $wrapper.find('#header-search-form-wrapper').css('opacity', '');
            });
            // Add touch outside to close menus
            $(document).on('touchstart', function(e) {
                if (!$(e.target).closest('.menu-category').length) {

                    // Clear the tracking
                    openedMenus.clear();
                    openedLevel3Menus.clear();

                    // Close all menus
                    $('.menu-category.menu-category-hover').removeClass('menu-category-hover no-transition');
                    $('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');
                    $('.js-menu-item-wrapper.active').removeClass('active');
                    $('.js-menu-item-wrapper.keyboard-hover').removeClass('keyboard-hover');
                    $('.js-menu-sub-level.nested-item-active').removeClass('nested-item-active');

                    menuEmitter.emit('closed');
                }
            });

        } else {
            var $menuTimer,
                $transitionTimer,
                $currentlyFocusedMenuButton = null;
            $('.menu-category').on('mouseenter', function() {
                var $el = $(this);
                if (!$el.hasClass('menu-category-hover')) {
                    // Reset keyboard focus tracking since mouse took over
                    $currentlyFocusedMenuButton = null;
                    $menuTimer = setTimeout(function() {
                        $el.addClass('menu-category-hover');

                        // Set ARIA expanded for dropdown items in this category
                        $el.find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'true');

                        // existing transition code
                        $transitionTimer = setTimeout(function() {
                            $el.addClass('no-transition');
                        }, SitePreferences.MENU_TRANSITION_DURATION + 20);
                    }, SitePreferences.MENU_HOVER_DELAY);
                }
                menuEmitter.emit('opened');
            }).on('mouseleave', function(e) {
                var $target = $(e.toElement || e.relatedTarget);
                if (!$target.closest('.menu-category-hover').length) {

                    // Reset keyboard focus tracking since mouse closed the menu
                    $currentlyFocusedMenuButton = null;
                    clearTimeout($menuTimer);
                    clearTimeout($transitionTimer);

                    // Reset ARIA expanded when leaving menu category
                    $(this).find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');
                    $(this).removeClass('menu-category-hover no-transition');

                    // Clean up focusout handler
                    $(this).off('focusout.submenu');
                }
                menuEmitter.emit('closed');
            });

            $('.js-menu-item').on('mouseenter', function () {
                var $menuItem = $(this);
                var $parentWrapper = $menuItem.closest('.js-menu-item-wrapper');
                var $level2Div = $parentWrapper.find('div.level-2');
                // Remove hidden class from this specific level-2 div
                if ($level2Div.length) {
                    $level2Div.removeClass('hidden');
                }
            });

            $('div.level-2').on('mouseleave', function(e) {
                var $target = $(e.toElement || e.relatedTarget);
                var $level2Div = $(this);

                var $parentWrapper = $level2Div.closest('.js-menu-item-wrapper');
                if (!$target.closest($parentWrapper).length) {
                    $level2Div.addClass('hidden');
                }
            });

            $('a[id^="menu-button-"]').on('keydown', function(e) {
                if (e.key === ' ') {

                    var $menuButton = $(this);
                    var $menuLi = $menuButton.closest('.js-menu-item-wrapper');
                    var $el = $menuButton.closest('.menu-category');
                    var $level2Div = $menuLi.find('div.level-2');

                    // Check if menu is currently open
                    var isOpen = $el.hasClass('menu-category-hover');

                    if (e.key === ' ' && !isOpen) {

                        // Store reference to this button for focus restoration
                        $currentlyFocusedMenuButton = $menuButton;

                        // Open the menu (your existing code)
                        $menuTimer = setTimeout(function() {
                            $el.addClass('menu-category-hover');
                            $el.find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'true');
                            $menuLi.addClass('keyboard-hover');
                            if ($level2Div.length) {
                                $level2Div.removeClass('hidden');
                            }

                            // Add focusout handler to auto-close when tabbing out
                            $el.on('focusout.submenu', function() {
                                // Small delay to let focus settle on new element
                                setTimeout(function() {
                                    var $newFocus = $(document.activeElement);

                                    // If focus moved outside this menu category, close it
                                    if ($newFocus.closest('.level-2').length === 0) {

                                        clearTimeout($menuTimer);
                                        clearTimeout($transitionTimer);

                                        $el.removeClass('menu-category-hover no-transition');
                                        $menuLi.removeClass('keyboard-hover');
                                        $el.find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');

                                        // Remove the focusout handler
                                        $el.off('focusout.submenu');

                                        // Reset focus tracking since we're auto-closing
                                        $currentlyFocusedMenuButton = null;

                                        menuEmitter.emit('closed');
                                    }
                                }, 10);
                            });

                            $transitionTimer = setTimeout(function() {
                                $el.addClass('no-transition');
                            }, SitePreferences.MENU_TRANSITION_DURATION + 20);
                        }, SitePreferences.MENU_HOVER_DELAY);

                        menuEmitter.emit('opened');
                    }
                }
            });

            $(document).on('keydown', function(e) {
                if (e.key === 'Escape') {
                    // Close any open menus
                    var $openMenus = $('.menu-category.menu-category-hover');

                    if ($openMenus.length) {

                        e.preventDefault();

                        $openMenus.each(function() {
                            var $menu = $(this);
                            var $menuLi = $menu.find('.js-menu-item-wrapper.keyboard-hover');

                            clearTimeout($menuTimer);
                            clearTimeout($transitionTimer);

                            $menu.removeClass('menu-category-hover no-transition');
                            $menuLi.removeClass('keyboard-hover');
                            $menu.find('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');

                            // Hide all level-2 divs when closing menu
                            $menu.find('div.level-2').addClass('hidden');

                            // Clean up focusout handler from level-2
                            $menu.find('.level-2').off('focusout.submenu');
                        });

                        // Restore focus to the original menu button
                        if ($currentlyFocusedMenuButton && $currentlyFocusedMenuButton.length) {
                            $currentlyFocusedMenuButton.focus();
                            $currentlyFocusedMenuButton = null; // Reset the reference
                        }

                        menuEmitter.emit('closed');
                    }
                }
                if (e.key === ' ') {
                    var $target = $(e.target);

                    var isMenuButton = $target.is('a[id^="menu-button-"]');
                    var isInMenu = $target.closest('.menu-category').length > 0;
                    var hasOpenMenus = $('.menu-category.menu-category-hover').length > 0;

                    if (isMenuButton || isInMenu || hasOpenMenus) {
                        e.preventDefault();
                    }
                }
            });
        }
        $header.on('click', '.js-user-account', function (e) {
            e.preventDefault();
            $(this).closest('.js-user-info').toggleClass('active');
            return false;
        });
    }
}

/**
 * Returns true if Hamburger menu rendered.
 * Idea: https://gomakethings.com/the-easy-way-to-manage-css-breakpoints-in-javascript/
 * @returns {boolean}
 */
function isHamburgerMenu() {
    const nav = document.getElementById('navigation');
    return nav && (util.getCSSContentValue(nav) === 'js-hamburger');
}

/**
 * @description Moved from SG app.js
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }

    if ($('.user-agent-header').length) {
        $('body').addClass('user-agent-logged');
    }
    // load js specific styles

    if (document.cookie.length === 0) {
        $('<div/>').addClass('browser-compatibility-alert no-cookies').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
    }

    // open current category in Mobile Hamburger menu
    if (isHamburgerMenu()) {
        var navPath = window.pageContext && window.pageContext.navPath || [];
        var $itemWrapper = $('#navigation');
        for (let i = 0; i < navPath.length; i++) {
            const cgid = navPath[i];
            $itemWrapper = $itemWrapper.find(`.js-menu-item-wrapper[data-cgid="${cgid}"]`);  // go down by nav tree

            if ($itemWrapper.length && $itemWrapper.find('.js-menu-sub-level').length) {
                $itemWrapper.addClass('active')
                    .closest('.js-menu-sub-level').addClass('nested-item-active');
            } else {
                break;
            }
        }
    }
}

function initializeMenuARIA() {
    // Ensure all dropdown menu items start with aria-expanded="false"
    $('.js-menu-item[aria-haspopup="true"]').attr('aria-expanded', 'false');
    $('div.level-2').addClass('hidden');
}

module.exports = {
    'init' : function () {
        initializeDom();
        initializeEvents();
        initializeMenuARIA();
    }
};
